import { Toggle } from "@/components/ui/toggle";

interface BillingToggleProps {
  isAnnual: boolean;
  setIsAnnual: (value: boolean) => void;
}

export const BillingToggle = ({ isAnnual, setIsAnnual }: BillingToggleProps) => {
  return (
    <div className="flex items-center justify-center gap-3">
      <span 
        className={`text-sm font-medium ${
          !isAnnual ? 'text-primary' : 'text-muted-foreground'
        }`}
      >
        Monthly
      </span>
      <div className="relative inline-flex">
        <Toggle
          pressed={isAnnual}
          onPressedChange={setIsAnnual}
          className={`
            w-14 h-7 rounded-full transition-colors duration-200
            bg-muted hover:bg-muted/90
            data-[state=on]:bg-primary data-[state=on]:hover:bg-primary/90
            relative
          `}
        >
          <div
            className={`
              absolute top-[2px] left-[2px] w-6 h-6 rounded-full 
              bg-white shadow-sm transform transition-transform duration-200
              ${isAnnual ? 'translate-x-7' : 'translate-x-0'}
            `}
          />
        </Toggle>
        {isAnnual && (
          <div className="absolute -top-7 left-1/2 -translate-x-1/2 whitespace-nowrap">
            <span className="bg-green-100 text-green-600 text-xs font-semibold px-2 py-1 rounded-full">
              Save 20%
            </span>
          </div>
        )}
      </div>
      <span 
        className={`text-sm font-medium ${
          isAnnual ? 'text-primary' : 'text-muted-foreground'
        }`}
      >
        Annually
      </span>
    </div>
  );
};